import EventCode from '@/models/eventCode'

export default {
  namespaced: true,
  state: {
    schema: EventCode.schema(),
    count: 0,
    count_table: 0,
    page: 1,
    maxValue: 0,
    metrics: {
      'Ocean Insights quality': {
        type: 'internal',
        average_shipments_with_eta_per_carrier: {
          labels: ['carrier_scac'],
          data: ['avg'],
          name: 'Average shipments with eta per carrier',
          mapDataTitles: {avg: 'percentage'}
        },
        average_shipments_with_eta_per_route: {
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['avg'],
          name: 'Average shipments with eta per route',
          clickUrl: 'average_shipments_with_eta_per_route',
          mapDataTitles: {avg: 'percentage'}
        },
        average_shipments_with_predicted_eta_per_carrier: {
          labels: ['carrier_scac'],
          data: ['avg'],
          name: 'Average shipments with predicted eta per carrier',
          mapDataTitles: {avg: 'percentage'}
        },
        average_shipments_with_predicted_eta_per_route: {
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['avg'],
          name: 'Average shipments with predicted eta per route',
          clickUrl: 'average_shipments_with_predicted_eta_per_carrier',
          mapDataTitles: {avg: 'percentage'}
        }
      },
      'Customer Tracking': {
        type: 'internal',
        count_shipments_per_company_and_month: {
          labels: ['company'],
          data: ['total'],
          specialFormat: groupByYearLabel,
          name: 'Count shipments per company and month'
        },
        count_shipments_per_user_and_month: {
          labels: ['user'],
          data: ['total'],
          specialFormat: groupByYearLabel,
          name: 'Count shipments per user and month'
        },
        count_shipments_per_company: {
          labels: ['company'],
          data: ['total'],
          name: 'Count shipments per company'
        },
        count_shipments_per_user: {
          labels: ['user'],
          data: ['total'],
          name: 'Count shipments per user'
        }
      },
      'Real Time': {
        type: 'client',
        count_active_shipments_per_carrier_and_shipment_status: {
          labels: ['carrier_scac'],
          data: [
            'total',
            'unknown',
            'waiting_for_pickup',
            'land_transport_to_POL',
            'in_POL_terminal',
            'waiting_for_departure_from_POL',
            'ocean_transport_from_POL',
            'in_transshipment',
            'ocean_transport_to_POD',
            'waiting_for_discharge_at_POD',
            'in_POD_terminal',
            'land_transport_to_Place_of_Delivery',
            'delivered_returning_container',
            'completed'
          ],
          hideTotal: true,
          name: 'Count active shipments per carrier and shipment status'
        },
        count_active_shipments_per_carrier_and_status: {
          labels: ['carrier_scac'],
          data: ['total', 'alerted', 'delayed'],
          hideTotal: true,
          name: 'Count active shipments per carrier and status'
        },
        count_stopped_shipments_per_carrier: {
          numericFilters: ['stopped_days'],
          labels: ['carrier_scac'],
          data: ['total'],
          name: 'Count stopped shipments per carrier'
        },
        count_stopped_shipments_per_route: {
          numericFilters: ['stopped_days'],
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['total'],
          name: 'Count stopped shipments per route',
          clickUrl: 'count_stopped_shipments_per_carrier'
        },
        count_dta_shipments_per_carrier: {
          numericFilters: ['dta'],
          labels: ['carrier_scac'],
          data: ['total'],
          name: 'Count dta shipments per carrier'
        },
        count_dta_shipments_per_pod: {
          numericFilters: ['dta'],
          labels: ['pod_loc__locode'],
          data: ['total'],
          name: 'Count dta shipments per pod',
          clickUrl: 'count_dta_shipments_per_carrier'
        }
      },
      'History evaluation': {
        type: 'client',
        min_avg_max_days_in_port_of_discharge: {
          labels: ['pod_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max days in port of discharge',
          isNotStacked: true
        },
        min_avg_max_days_in_port_of_loading: {
          labels: ['pol_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max days in port of loading',
          isNotStacked: true
        },
        min_avg_max_days_in_transhipment: {
          labels: ['tsp_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max days in transhipment',
          isNotStacked: true
        },
        min_avg_max_discrepancy_eta_at_pod_per_carrier: {
          labels: ['carrier_scac'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max discrepancy eta at pod per carrier',
          isNotStacked: true
        },
        min_avg_max_discrepancy_eta_at_pod_per_pod: {
          labels: ['pod_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max discrepancy eta at pod per pod',
          clickUrl: 'min_avg_max_discrepancy_eta_at_pod_per_carrier',
          isNotStacked: true
        },
        min_avg_max_discrepancy_eta_at_pod_per_route: {
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max discrepancy eta at pod per route',
          clickUrl: 'min_avg_max_discrepancy_eta_at_pod_per_carrier',
          isNotStacked: true
        },
        min_avg_max_transit_door_to_door_per_carrier: {
          labels: ['carrier_scac'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max transit door to door per carrier',
          isNotStacked: true
        },
        min_avg_max_transit_door_to_door_per_route: {
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max transit door to door per route',
          clickUrl: 'min_avg_max_transit_door_to_door_per_carrier',
          isNotStacked: true
        },
        min_avg_max_transit_port_to_port_per_carrier: {
          labels: ['carrier_scac'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max transit port to port per carrier',
          isNotStacked: true
        },
        min_avg_max_transit_port_to_port_per_route: {
          labels: ['pol_loc__locode', 'pod_loc__locode'],
          data: ['min', 'avg', 'max'],
          name: 'Min avg max transit port to port per route',
          clickUrl: 'min_avg_max_transit_port_to_port_per_carrier',
          isNotStacked: true
        }
      },
      'Shipments': {
        type: 'client',
        shipments_without_planned_initial_at_pod: {
          labels: [],
          data: [],
          specialFormat: noFormatData,
          specialType: 'table',
          name: 'Shipments whitout planned initial at POD',
          entity: 'shipments',
          url: 'shipment',
          schema: 'shipment',
          columns: [
            'id',
            'status_verbose',
            'health',
            'last_alert_code',
            'container_number',
            'bl_or_booking_number',
            'client_code',
            'carrier_name',
            'pol_loc',
            'pod_loc',
            'etd',
            'atd',
            'dtd',
            'eta',
            'ata',
            'dta',
            'discrepancy_eta_at_pod',
            'discrepancy_eta_at_dlv',
            'days_in_tsp',
            'days_in_tsp_planned_initial',
            'days_in_pol_planned_initial',
            'days_in_pod_planned_initial',
            'days_in_tsp_planned_last',
            'days_in_pol_planned_last',
            'days_in_pod_planned_last',
            'sf_data',
            'last_update',
            'storage_days_at_pol',
            'storage_days_at_pod',
            'created_at'
          ]
        },
        shipments_completed_not_returned: {
          labels: [],
          data: [],
          specialFormat: noFormatData,
          specialType: 'table',
          name: 'Shipments completed not returned',
          entity: 'shipments',
          url: 'shipment',
          schema: 'shipment',
          columns: [
            'id',
            'status_verbose',
            'health',
            'last_alert_code',
            'container_number',
            'bl_or_booking_number',
            'client_code',
            'carrier_name',
            'pol_loc',
            'pod_loc',
            'etd',
            'atd',
            'dtd',
            'eta',
            'ata',
            'dta',
            'discrepancy_eta_at_pod',
            'discrepancy_eta_at_dlv',
            'days_in_tsp',
            'days_in_tsp_planned_initial',
            'days_in_pol_planned_initial',
            'days_in_pod_planned_initial',
            'days_in_tsp_planned_last',
            'days_in_pol_planned_last',
            'days_in_pod_planned_last',
            'sf_data',
            'last_update',
            'storage_days_at_pol',
            'storage_days_at_pod',
            'created_at'
          ]
        }
      }
    },
    mapDataTitles: {
      avg: 'percentage'
    }
  },
  actions: {
    async list ({ dispatch, state }, params) {
      return dispatch('list', { modelClass: EventCode, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async listes ({ dispatch, state }, data) {
      if (data.params && !data.params.ordering) data.params.ordering = 'nombre'
      return dispatch('request', { url: `${data.url}`, method: 'get', params: data.params }, { root: true })
        .then(response => {
          state.count = response.data.count
          return response.data.results
        })
        .catch(error => { throw error })
    },
    async retrieve ({ dispatch, state }, id) {
      return dispatch('retrieve', { modelClass: EventCode, id: id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async get ({ dispatch, state }, params) {
      return dispatch('request', { url: 'bi/' + params.url, method: 'get', params: params.filters }, { root: true })
        .then(response => {
          if (state.metrics[params.category][params.url] && state.metrics[params.category][params.url].specialType === 'table') {
            state.count_table = response.data.count
          }
          state.count = response.data.count
          return parseData(response.data, params, state)
        })
        .catch(error => { throw error })
    },
    async getExport ({ dispatch, state }, params) {
      return dispatch('download', { url: 'bi/' + params.url + '/export', method: 'get', params: params.filters }, { root: true })
        .then(response => {
          state.count = response.data.count
          return parseData(response.data, params, state)
        })
        .catch(error => { throw error })
    }
  }
}
function parseData (data, params, state) {
  state.maxValue = 0
  var output = {labels: [], data: {}, results: []}
  var metric = state.metrics[params.category][params.url]
  if (metric.specialFormat) {
    return metric.specialFormat(state, data, metric.labels[0], metric.data[0])
  }
  data.forEach(result => {
    var label = ''
    metric.labels.forEach(lbl => {
      if (label) label += ' - '
      label += result[lbl]
    })
    output.labels.push(label)
    output.results.push(result)
    metric.data.forEach(data => {
      if (result[data]) {
        result[data] = result[data].toFixed(2)
      }
      var mapDataTitle = (metric.mapDataTitles && metric.mapDataTitles[data]) ? metric.mapDataTitles[data] : data
      if (!output.data[mapDataTitle]) output.data[mapDataTitle] = []
      output.data[mapDataTitle].push((mapDataTitle === 'percentage' ? result[data] * 100 : result[data]))
    })
  })
  return output
}

function groupByYearLabel (state, data, mainLabel, dataLabel) {
  var months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var years = {}
  data.forEach(result => {
    if (result[dataLabel] > state.maxValue) state.maxValue = result[dataLabel]
    if (!years[result.year]) years[result.year] = {}
    if (!years[result.year][months[result.month]]) years[result.year][months[result.month]] = {labels: [], data: {}, results: []}
    years[result.year][months[result.month]].results.push(result)
    years[result.year][months[result.month]].labels.push(result[mainLabel])
    if (!years[result.year][months[result.month]].data[dataLabel]) years[result.year][months[result.month]].data[dataLabel] = []
    years[result.year][months[result.month]].data[dataLabel].push(result[dataLabel])
  })
  return years
}

function noFormatData (state, data, mainLabel, dataLabel) {
  return data.results
}



// WEBPACK FOOTER //
// ./src/store/bi.js